(() => {
  const CFG = {
    maxOffset: 40,
    vars: ["--bg-offset-x", "--frame-offset-x", "--glow-offset-x"],
  };

  const handleMove = (btn) => (e) => {
    const { left, width } = btn.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const relativeX = (clientX - left - width / 2) / (width / 2); // −1 → 1
    const px = relativeX * CFG.maxOffset;

    CFG.vars.forEach((v) => btn.style.setProperty(v, `${px}px`));
  };

  const handleLeave = (btn) => () =>
    CFG.vars.forEach((v) => btn.style.removeProperty(v));

  /* ——— wire it up once per button ——— */
  document.querySelectorAll(".btn").forEach((btn) => {
    const move = handleMove(btn);
    const reset = handleLeave(btn);

    btn.addEventListener("pointermove", move);
    btn.addEventListener("pointerleave", reset);
    btn.addEventListener("pointercancel", reset);
    btn.addEventListener("touchmove", move, { passive: true });
    btn.addEventListener("touchend", reset);
    btn.addEventListener("blur", reset);
  });
})();
